import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { isLoggedIn, getUserRole, isIpAllowed } from "./auth";
import NotAllowedIpPage from "./../pages/Restrict/NotAllowedIpPage";
import NotAuthorizedPage from "./../pages/Restrict/NotAuthorizedPage";

export default function AccessControlRoute({ children }) {
    const [ipAllowed, setIpAllowed] = useState(null);

    const AdminRole = "Admin";
    const ModeratorRole = "Moderator";

    useEffect(() => {
        async function checkIp() {
            const allowed = await isIpAllowed();
            setIpAllowed(allowed);
        }
        if (isLoggedIn()) {
            checkIp();
        }
    }, []);

    if (!isLoggedIn()) {
        return <Navigate to="/login" />;
    }

    if (ipAllowed === null) {
        return <div>Checking access...</div>;
    }

    if (!ipAllowed) {
        return <NotAllowedIpPage />;
    }

    const role = getUserRole();
    if (role !== AdminRole && role !== ModeratorRole) {
        return <NotAuthorizedPage />;
    }

    return children;
}
